export const SET_PROTUCTS = "SET_PRODUCTS"

export const SELECTED_PRODUCT = "SELECTED_PRODUCT"

export const REMOVE_SELECTED_PRODUCT = "REMOVE_SELECTED_PRODUCT"

export const SET_PRODUCT_MATERIAL = "SET_PRODUCT_MATERIAL"